<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="addOrEdit" v-if="+project.projectstatus < 50" :loading="btnLoading">确认</el-button>
      <span class="status"v-if="+project.projectstatus >= 50" >评分已确认</span>
      <span style="margin-left: 50px;" >项目名称：{{project.projectcode}}-{{project.projectname}}</span>
    </div>
    <el-table :data="pgsList"  style="" height="400" border @cell-click="cellClick">
      <el-table-column type="index" label="行号" width="50"></el-table-column>
      <el-table-column label="供应商" prop="pgscomname" width="100"></el-table-column>
      <el-table-column label="价格"  width="100">
        <template slot-scope="scope">
          {{scope.row.pgsamt | qfwVal}}
        </template>
      </el-table-column>
      <div v-for="(pg,index) in pgList" :key="index">
        <el-table-column :label="pg.pgname" width="100" :index="index">
          <template slot-scope="scope">
            {{scope.row.pgsas[0].pgsas}}
          </template>
        </el-table-column>
        <el-table-column label="百分比" width="100">
          <template slot-scope="scope">
            {{scope.row.pgsas[0].pgsratio}}
          </template>
        </el-table-column>
      </div>
      <el-table-column label="总分" prop="pgsts" width="100"></el-table-column>
<!--      <el-table-column label="评审人意见" prop="">-->
<!--        <template slot-scope="scope">-->
<!--          <el-input v-model="scope.row.pgsdesc" :maxlength="255" type="textarea" :disabled="disable"></el-input>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "pgsForm",
    data () {
      return {
        project: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        pgsList: [],
        pgList: [],
        pgsItemList: [],
        pgs: {},
        pgIndex: -1
      }
    },
    created () {
    },
    async activated() {
      await this.init()
      await this.getPgList()
      await this.getPgsList()
    },
    watch: {
    },
    filters: {
      newDateTime (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
      },
      qfwVal(value) {
        return utils.comdify(value)
      }
    },
    components: {},
    computed: {
    },
    methods: {
      async init() {
        this.project = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.pgsList = []
        this.pgList = []
        this.pgsItemList = []
        this.pgs = {}
        this.pgIndex = -1
      },
      async initpgs() {
        let data = await request({
          url: '/xmgl/pgs/initPgs',
          method: "post",
          data: {projectid: this.project.projectid,userid: this.$store.getters.loginUser.userid}
        })
        if (data.issuccess===1) {
          await this.getPgsList()
          this.$message.success('初始化完毕！')
        } else if (data.issuccess===2) {
        } else {
          this.$message.error('初始化失败！')
        }
      },
      async cellClick(row, column, cell, event) {
        if (column.index >= 0) {
          this.pgs = row
          this.pgIndex = column.index
          this.pgsItemList = row.pgsas[column.index].pgsitems
        }
      },
      async getPgList() {
        this.pgList = await request({
          method: 'get',
          url: '/xmgl/project/getPgList',
          params: {projectid: this.project.projectid}
        })
        console.log('-=-=-=-this.pgList=-=-=',this.pgList);
        
      },
      
      async getPgsList () {
        this.pgsList = await request({
          method: 'get',
          url: '/xmgl/pgs/getPgsList',
          params: {projectid: this.project.projectid}
        })
        console.log('=====this.pgsList======',this.pgsList)
      },
      async addOrEdit () {
        this.btnLoading = true
        if (+this.project.projectstatus > 40) {
          this.$message.warning(`项目已进入${this.project.projectstatusname}不能做评分确认!`)
          return
        }
        let model = {
          userid: this.$store.getters.loginUser.userid,
          projectid: this.project.projectid,
          pgsList: this.pgsList
        }

        let data = await request({
          url: '/xmgl/pgs/savePgs',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.project.projectstatus = '50'
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
        this.btnLoading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pgsIndex'})
      }
    }
  }
</script>

<style lang="scss">
  .status {
    color: red;
    padding-left: 10px;
  }

</style>
